import React from 'react';
import { TrendingUpIcon, ShieldIcon, BrainIcon, BarChartIcon } from 'lucide-react';
export const Features = () => {
  const features = [{
    icon: <TrendingUpIcon className="h-10 w-10 text-blue-600" data-id="element-81" />,
    title: '高效算法策略',
    description: '基于大数据分析和机器学习的量化交易算法，捕捉市场机会，提高交易效率。'
  }, {
    icon: <ShieldIcon className="h-10 w-10 text-blue-600" data-id="element-82" />,
    title: '风险控制',
    description: '严格的风险管理系统，多层次的风控措施，确保资金安全和投资稳健。'
  }, {
    icon: <BrainIcon className="h-10 w-10 text-blue-600" data-id="element-83" />,
    title: 'AI智能分析',
    description: '人工智能技术辅助分析市场趋势，实时调整策略，优化投资组合。'
  }, {
    icon: <BarChartIcon className="h-10 w-10 text-blue-600" data-id="element-84" />,
    title: '透明业绩报告',
    description: '定期提供详细的业绩报告和策略分析，让您全面了解投资情况。'
  }];
  return <section id="features" className="py-16 bg-gray-50 w-full" data-id="element-85">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-86">
        <div className="text-center mb-16" data-id="element-87">
          <h2 className="text-3xl font-bold text-gray-900" data-id="element-88">
            我们的量化交易优势
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-89">
            极客quant团队拥有丰富的金融市场经验和技术背景，为您提供专业的量化交易解决方案。
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-90">
          {features.map((feature, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300" data-id="element-91">
              <div className="mb-4" data-id="element-92">{feature.icon}</div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-93">
                {feature.title}
              </h3>
              <p className="text-gray-600" data-id="element-94">{feature.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
};